import SearchSelect from "Components/molecule/inputs/search-select"
import SelectInput, { SelectOption } from "Components/molecule/inputs/select-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormContainer from "Components/atoms/containers/form-container"
import FormProps from "data/forms"
import DepartmentPermissionFields from "./types"

interface DepartmentPermissionFormProps extends FormProps<DepartmentPermissionFields> {
    employees: SelectOption[]
    permissionTypes: SelectOption[]
}

const EMPLOYEE_KEY = "employeeId";
const PERMISSION_TYPE_KEY = "permissionTypeName";

const DepartmentPermissionForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
    employees,
    permissionTypes
}: DepartmentPermissionFormProps) => {

    return <FormContainer
        inputs={<>
            <SearchSelect
                name={EMPLOYEE_KEY}
                key={EMPLOYEE_KEY}
                label={"Employee*"}
                placeholder={"Search employee..."}
                value={values.employeeId}
                error={!!touched.employeeId && !!errors.employeeId}
                message={touched.employeeId ? errors.employeeId : undefined}
                options={employees}
                onChange={(option: SelectOption | null) => handleChange(EMPLOYEE_KEY)(option ? option.value : '')}
                onBlur={handleBlur(EMPLOYEE_KEY)}
            />

            <SelectInput
                touched={!!touched.permissionTypeName}
                name={PERMISSION_TYPE_KEY}
                key={PERMISSION_TYPE_KEY}
                label={"Permission*"}
                placeholder={"Select a permission"}
                options={permissionTypes}
                value={values.permissionTypeName}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.permissionTypeName && !!errors.permissionTypeName}
                message={touched.permissionTypeName ? errors.permissionTypeName : undefined}
            />
        </>}
        buttons={
            <PrimaryButton
                type='submit'
                onClick={() => handleSubmit()}
                disabled={isSubmitting || !isValid}
                className="w-100"
            >
                {isSubmitting ? "Granting...." : "Grant Permission"}
            </PrimaryButton>
        }
    />
}

export default DepartmentPermissionForm
